<template>
  <div class="login-block">
    <div class="login-title">
      <h5>用户注册</h5>
      <p>万科域账号可直接登录</p>
    </div>
    <el-form
      ref="phoneLogin"
      class="login-form"
      :model="phoneLogin"
      :rules="rules"
      v-on:submit.prevent="submitForm"
      :show-message="false"
      size="medium"
    >
      <el-form-item prop="name">
        <el-input
          v-model="phoneLogin.name"
          :clearable="true"
          placeholder="用户名 (2-6位中文)"
          v-on:keyup.enter.native="submitForm"
          maxlength="6"
        ></el-input>
      </el-form-item>
      <el-form-item prop="telNumber">
        <el-input
          v-model="phoneLogin.telNumber"
          maxlength="11"
          :clearable="true"
          placeholder="手机"
          v-on:keyup.enter.native="submitForm"
        ></el-input>
      </el-form-item>
      <el-form-item prop="verCode" class="pr">
        <el-input
          v-model="phoneLogin.verCode"
          maxlength="6"
          placeholder="验证码"
          v-on:keyup.enter.native="submitForm"
        ></el-input>
        <v-code
          class="vcode"
          session-name="TIME_ACCOUNT_SIGNUP"
          action-path="/user-server/user/sendShortMessage"
          :action-data="actionData"
          @send="handleSend"
        ></v-code>
      </el-form-item>
    </el-form>
    <div class="link-box clearfix">
      <el-checkbox v-model="isChecked">
        知悉并接受
        <router-link to="/privacy" class="link primary" target="_blank"
          >《隐私政策》</router-link
        >与
        <router-link to="/service" class="link primary" target="_blank"
          >《服务协议》</router-link
        >
      </el-checkbox>
    </div>
    <div class="btn-box">
      <v-button @click="submitForm" :disabled="!isChecked" :loading="loading"
        >注&emsp;册</v-button
      >
    </div>
  </div>
</template>

<script>
import vCode from '@/components/vCode'
import vButton from './vButton.vue'

export default {
  components: {
    vCode,
    vButton
  },
  data() {
    // 判断中文名称
    const chinese = (rule, value, callback) => {
      var sum = 0
      for (var i = 0; i < value.length; i++) {
        var c = value.charCodeAt(i)
        if (!((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f))) {
          sum += 2
        } else {
          callback(new Error('请输入2-6位中文字符'))
        }
      }
      if (sum >= 4 && sum <= 12) {
        callback()
      } else {
        callback(new Error('请输入2-6位中文字符'))
      }
    }
    // mobile validator
    const validateMobile = (rule, value, callback) => {
      let reg = /^1/
      if (!reg.test(value)) {
        callback(new Error('手机格式有误'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      errMessage: '',
      // 是否同意协议
      isChecked: false,
      // 表单
      phoneLogin: {
        telNumber: '',
        verCode: '',
        name: ''
      },
      rules: {
        name: [{ validator: chinese, trigger: 'change' }],
        telNumber: [{ validator: validateMobile, trigger: 'change' }],
        verCode: [
          { required: true, message: '请输入验证码', trigger: 'change' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionData: function() {
      return {
        phoneNo: this.phoneLogin.telNumber,
        motion: 'register'
      }
    }
  },
  methods: {
    doLoading() {
      this.loading = true
    },
    doCloseLoading() {
      this.loading = false
    },
    // vcode callback
    handleSend(t) {},

    // 提交表单
    submitForm() {
      this.$refs.phoneLogin.validate(valid => {
        if (valid) {
          this.doLoading()
          // this.$eventHub.$emit("loading");
          this.$http
            .post('/user-server/user/userRegist', {
              userName: this.phoneLogin.name,
              phoneNo: this.phoneLogin.telNumber,
              verificationCode: this.phoneLogin.verCode
            })
            .then(res => {
              this.doCloseLoading()
              // this.$eventHub.$emit("close-loading");
              if (res.data.code == 200) {
                this.$emit('update', 'signupS')
                this.$message.success(res.data.message)
              } else {
                this.$message.error(res.data.message)
              }
            })
            .catch(err => {
              this.doCloseLoading()
              // this.$eventHub.$emit("close-loading");
              console.log('ERROR', err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '../styles/login.scss';
</style>
<style lang="scss">
@import '../styles/form.scss';
</style>



// WEBPACK FOOTER //
// src/views/index/components/signupA.vue